import { RootState } from 'store';

// eslint-disable-next-line import/prefer-default-export
export const selectRosterComparisonIsLoading = (state: RootState): boolean => state.rosterComparison.isLoading;
